import { BookingSource, CreateBookingDto, BookingDto } from '@shared/core/bookings'
import { useMutation, useQueryClient } from 'react-query'
import { BookingsService } from 'src/services/bookings.service'
import { ensureUserIdPrefix } from '../utils/user-id'

// Cache key
export const CREATE_BOOKING_CACHE_KEY = 'create-booking'

// Every booking created through this SPA hook comes from the web booking page.
const SPA_BOOKING_SOURCE: BookingSource = 'web'

// Create booking
export function useCreateBooking() {
  const queryClient = useQueryClient()
  return useMutation(
    CREATE_BOOKING_CACHE_KEY,
    (dto: CreateBookingDto) =>
      BookingsService.createBooking({
        booking_source: SPA_BOOKING_SOURCE,
        ...dto,
        provider_id: ensureUserIdPrefix(dto.provider_id),
      }),
    {
      onSuccess: () => {
        // Invalidate any booking-related queries if needed
        // For now, we don't have queries that need invalidation
      },
    },
  )
}
